export const css = {
    oneaction: '_3j42TDyS',
    ' _key': 'ascm-theme/ascm/quiz-widgets/discussion'
};
export default css;
